<div class="diagnosticproduct-student-header-taskbar" [class.hide-overflow]="animationComplete" [style.background]="' ' + taskBarColor + ' '">
  <div class='task_bar_title font-24'>{{title}}</div>
  <total-points [totalPoints]="totalPoints()"></total-points>
  @if (backButtonVisible) {
    <button class='task_bar_button' [class.back_button_animate]="isPulse" (click)="onBackButtonPress()" [disabled]="disableBackButton"
    ></button>
  }
  @if (taskBarTaskDetailsVisible) {
    <div class='task_bar_right_container'>
      <img [src]=taskIcon class="task_bar_task_icon task_bar_task_icon_height" [class.animate]="animate">
      <div class='vertical_text_container'>
        <p class="task_bar_task_name font-task-bar-name" [class]="{ 'long' : taskName.length >= 20, 'animate': animate }">{{taskName}}</p>
        <p class="task_bar_task_subtext font-13" [class.animate]="animate">{{taskSubtext}}</p>
      </div>
    </div>
  }
</div>
@if (showBackDialog) {
  <wf-intervention-back-dialog (onPress)="onBackDialogPress($event)" />
}
